import React from "react";
import ReactECharts from "echarts-for-react";

const BarChart = ({ score = {}, maxScore }) => {
  const currentYear = new Date().getFullYear();

  const individualScore = score?.individual_score ?? null;
  const departmentAverage = score?.average_scores?.department_average ?? null;
  const populationAverage = score?.average_scores?.org_average ?? null;
  const platformAverage = score?.average_scores?.platform_average ?? null;

  const series = [];

  if (individualScore !== null) {
    series.push({
      name: "Individual",
      type: "bar",
      data: [individualScore],
      barWidth: "35px",
    });
  }

  if (departmentAverage !== null) {
    series.push({
      name: "Department",
      type: "bar",
      data: [departmentAverage],
      barWidth: "35px",
    });
  }

  if (populationAverage !== null) {
    series.push({
      name: "Organization",
      type: "bar",
      data: [populationAverage],
      barWidth: "35px",
    });
  }

  if (platformAverage !== null) {
    series.push({
      name: "Platform",
      type: "bar",
      data: [platformAverage],
      barWidth: "35px",
    });
  }

  const option = {
    color: ["#FBCEBD", "#97C8E9", "#82C799", "#FFD700"],
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
    },
    legend: {
      data: series?.map((s) => s.name),
      top: "top",
    },
    grid: {
      left: "3%",
      right: "4%",
      bottom: "3%",
      containLabel: true,
    },
    xAxis: {
      type: "category",
      data: [currentYear],
    },
    yAxis: {
      type: "value",
      min: 0,
      max: maxScore,
    },
    series,
  };

  return (
    <div id="chart1">
      <ReactECharts option={option} style={{ height: 270 }} />
    </div>
  );
};

export default BarChart;
